(function () {
  var stickySelector = ".product__popup.sticky-bar, .myline-mobile-sticky, [data-myline-sticky]";

  function syncStickyWithMobileMenu() {
    var sticky = document.querySelector(stickySelector);
    if (!sticky) return;

    if (
      document.body.classList.contains("overflow-hidden-drawer") ||
      document.body.classList.contains("overflow-hidden-tablet")
    ) {
      sticky.dataset.mylineMenuHidden = "true";
      sticky.style.setProperty("display", "none", "important");
      sticky.style.setProperty("visibility", "hidden", "important");
      sticky.style.setProperty("pointer-events", "none", "important");
      setTimeout(function () {
        if (
          document.body.classList.contains("overflow-hidden-drawer") ||
          document.body.classList.contains("overflow-hidden-tablet")
        ) {
          sticky.style.setProperty("display", "none", "important");
          sticky.style.setProperty("visibility", "hidden", "important");
          sticky.style.setProperty("pointer-events", "none", "important");
        }
      }, 0);
      return;
    }

    if (sticky.dataset.mylineMenuHidden === "true") {
      delete sticky.dataset.mylineMenuHidden;
      sticky.style.removeProperty("display");
      sticky.style.removeProperty("visibility");
      sticky.style.removeProperty("pointer-events");
      window.dispatchEvent(new Event("scroll"));
    }
  }

  function init() {
    new MutationObserver(syncStickyWithMobileMenu).observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    var sticky = document.querySelector(stickySelector);
    if (sticky) {
      new MutationObserver(function () {
        var menuIsOpen =
          document.body.classList.contains("overflow-hidden-drawer") ||
          document.body.classList.contains("overflow-hidden-tablet");
        var stickyWasRestored =
          sticky.style.getPropertyValue("display") !== "none" ||
          sticky.style.getPropertyValue("visibility") !== "hidden" ||
          sticky.style.getPropertyValue("pointer-events") !== "none";

        if (menuIsOpen && stickyWasRestored) syncStickyWithMobileMenu();
      }).observe(sticky, {
        attributes: true,
        attributeFilter: ["style"],
      });
    }

    syncStickyWithMobileMenu();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
